import { OrganisationService } from '../../service/organisation/organisation.service';
import { Directive, Input, inject } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of, switchMap, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Directive({
    selector: '[uflaUniqueEicnummer]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: UniqueEicnummerDirective,
            multi: true,
        },
    ],
    standalone: false,
})
export class UniqueEicnummerDirective {
    private organisationService = inject(OrganisationService);

  @Input() uflaUniqueEicnummer: string;

  validate(nameControl: AbstractControl): Observable<ValidationErrors | null> | ValidationErrors {
      {
          if (!nameControl.value || this.uflaUniqueEicnummer === nameControl.value) {
              return of(null);
          }

          return timer(500).pipe(
              switchMap(() => this.organisationService.existsInEic1OrEic2OrEic3(nameControl.value)),
              map(exists => exists ? { uniqueEicNummer: true } : null),
          );
      }
  }

}
